import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '~/components/modal';
import './index.less';

export default function ViOfflineModal() {
  const { t, i18n } = useTranslation();
  const [showShopPop, setShowShopPop] = useState(false);
  const hideShopPop = () => {
    setShowShopPop(false);
  };

  const handleViOfflineGo = () => {
    hideShopPop();
    window.open('https://www.marvelsnap.com/home/newsdetail?id=7473801480722553655');
  };

  useEffect(() => {
    if (i18n.language === 'vi') {
      setShowShopPop(true);
    }
  }, [i18n.language]);

  return (
    <Modal show={showShopPop} onClose={hideShopPop} showClose={true}>
      <div styleName="vi-offline">
        <div styleName="text">MARVEL SNAP Ngừng Hoạt Động Tại Việt Nam.</div>
        <div styleName="btn" onClick={handleViOfflineGo}>
          {t('Tuesday_go')}
        </div>
      </div>
    </Modal>
  );
}
